<template>
  <b-row class="vh-100 vw-100 row-login">
    <!-- Overlay de carregamento -->
    <div v-if="isLoading" class="loading-overlay">
      <i class="fas fa-spinner fa-spin loading-icon"></i>
    </div>

    <!-- Coluna de formulário de login -->
    <b-col sm="4" class="d-flex justify-content-center align-items-center left-login">
      <div class="col-8">
        <div class="text-center mb-3">
          <img src="../assets/logo-gestauto.jpg" alt="Logo" class="login-logo" />
        </div>
        <h2 class="text-center mb-5 title-login">Login</h2>
        <b-form @submit.prevent="login">
          <b-form-group class="tittle-lable" label="E-mail" label-for="username">
            <b-form-input
              id="email"
              type="email"
              placeholder="seuemail@mail.com.br"
              autocomplete="off"
              v-model="form.username"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group class="tittle-lable" label="Senha" label-for="password">
            <b-form-input
              id="password"
              type="password"
              placeholder="Digite sua senha"
              v-model="form.password"
              required
              @keyup.enter="login"
            ></b-form-input>
          </b-form-group>

          <b-button type="button" class="btn-entrar" block @click="login" :disabled="isLoading">
            <i class="fas fa-sign-in-alt"></i> Entrar
          </b-button>
          <hr>

          <p v-if="error" class="text-danger mt-3">{{ error }}</p>
        </b-form>
      </div>
    </b-col>
    <!-- Coluna de imagem -->
    <b-col sm="8" class="d-flex justify-content-center align-items-center img-login">
      <!--img src="../assets/predio_gestauto_v2.jpg" class="img-login"-->
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      error: null,
      isLoading: false // Controle do estado de carregamento
    };
  },
  methods: {
    async login() {
      this.isLoading = true; // Ativa o estado de carregamento
      try {
        const params = new URLSearchParams();
        params.append("username", this.form.username);
        params.append("password", this.form.password);

        const response = await axios.post('https://api-autoatendimento.nextcomm.tech/login', params);
        //const response = await axios.post('http://127.0.0.1:19000/login', params);

        // Adicione o console.log para verificar a resposta da API
        console.log("Resposta da API de login:", response.data);

        if (response.data.access_token) {
          // Salva o token e o nome do usuário no localStorage
          localStorage.setItem('token', response.data.access_token);
          localStorage.setItem('nome_usuario', response.data.nome_usuario); // Certifique-se de que está capturando corretamente

          if (this.$route.name !== 'relato') {
            await this.$router.push({ name: 'relato' });
          }
        } else {
          this.error = 'Login falhou. Verifique suas credenciais.';
        }
      } catch (error) {
        this.error = error.response ? error.response.data.detail : error.message;
      } finally {
        this.isLoading = false; // Desativa o estado de carregamento
      }
    }
  }
};
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    text-decoration: none;
  }

  .row-login {
    margin-left: 0;
  }

  .left-login {
    background-color: #f2f2f2;
  }

  .title-login {
    font-weight: bold;
    color: #27471e;
  }

  /* Estilo da logo */
  .login-logo {
    max-width: 300px;
    height: auto;
  }

  .img-login {
    background: url(../assets/predio_gestauto_v2.jpg) no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-size: cover;
    background-position: center;
  }

  .btn-entrar {
    background-color: #27471e !important;
    color: white !important;
    border: none !important;
  }

  .btn-entrar:hover {
    background-color: #008a36 !important;
  }

  .tittle-lable {
    font-weight: bold;
    color: #27471e;
  }

  /* Estilo para input com sombra verde no foco */
  .b-form-input:focus,
    input[type="email"]:focus,
    input[type="password"]:focus {
    box-shadow: 0 0 5px 2px #00b044;
    border-color: #00b044;
    color: #27471e;
  }

  /* Overlay de carregamento */
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8); /* Fundo branco translúcido */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Colocar acima do conteúdo */
  }

  .loading-icon {
    font-size: 3rem;
    color: #008a36;
  }
</style>